<div class="content">
  <!-- <img src="../../../assets/images/logo.png" width="90px" height="90px" /> -->

  <p>一站式海外数字订阅平台</p>

  <div class="switch-type">
    <button
      [ngClass]="{ active: mode === 'phone' }"
      (click)="switchMode('phone')"
    >
      <span>手机登录</span>
    </button>
    <button
      [ngClass]="{ active: mode === 'email' }"
      (click)="switchMode('email')"
    >
      <span>邮箱登录</span>
    </button>
  </div>

  <ng-container *ngIf="mode === 'phone'">
    <div class="form">
      <mat-form-field appearance="outline">
        <mat-label>手机号</mat-label>
        <input
          matInput
          placeholder="请输入手机号"
          [(ngModel)]="phone"
          (keydown)="onPhoneKeydown($event)"
          (input)="onPhoneInput($event)"
        />
      </mat-form-field>

      <div class="field" *ngIf="method === 'Phone'">
        <mat-form-field appearance="outline">
          <mat-label>验证码</mat-label>
          <input matInput placeholder="请输入短信验证码" [(ngModel)]="code" />
        </mat-form-field>
        <button
          mat-stroked-button
          color="primary"
          (click)="sendCode()"
          [disabled]="!phone"
        >
          {{ timeout > 0 ? "等待(" + timeout + ")" : "发送验证码" }}
        </button>
      </div>

      <mat-form-field appearance="outline" *ngIf="method === 'Password'">
        <mat-label>密码</mat-label>
        <input
          matInput
          placeholder="请输入登录密码"
          type="password"
          [(ngModel)]="password"
        />
      </mat-form-field>

      <div class="agreement">
        <mat-checkbox [(ngModel)]="agree">
          已阅读并同意<a routerLink="/agreement">用户协议</a>和
          <a routerLink="/privacy">隐私协议</a>
        </mat-checkbox>
      </div>

      <button class="login" mat-raised-button color="primary" (click)="login()">
        {{ method === "Phone" ? "登录并注册" : "登录" }}
      </button>

      <div class="divider">
        <div class="dashed"></div>
        或者
        <div class="dashed"></div>
      </div>

      <button
        class="login-with-button"
        mat-stroked-button
        color="primary"
        (click)="method === 'Phone' ? usePassword() : usePhone()"
      >
        {{ method === "Phone" ? "使用密码登录" : "使用验证码登录" }}
      </button>
      <button
        class="login-with-button"
        mat-stroked-button
        color="primary"
        style="margin-left: 10px; display: none"
        (click)="loginWxQrcode()"
      >
        <div style="display: flex; align-items: center">
          <img
            src="../../../assets/images/weixin.svg"
            [width]="17"
            [height]="17"
            alt=""
            style="margin-right: 5px"
          />
          微信登录
        </div>
      </button>
    </div>

    <div style="flex: 1"></div>

    <div class="hint">暂不支持海外手机号获取验证码</div>
  </ng-container>

  <ng-container *ngIf="mode === 'email'">
    <div class="form">
      <mat-form-field appearance="outline">
        <mat-label>邮箱</mat-label>
        <input matInput placeholder="请输入邮箱" [(ngModel)]="email" />
      </mat-form-field>

      <div class="field" *ngIf="methodEmail === 'Email1'">
        <mat-form-field appearance="outline">
          <mat-label>验证码</mat-label>
          <input matInput placeholder="请输入邮箱验证码" [(ngModel)]="code" />
        </mat-form-field>
        <button
          mat-stroked-button
          color="primary"
          (click)="sendCodeEmail()"
          [disabled]="!email"
        >
          {{ timeout > 0 ? "等待(" + timeout + ")" : "发送验证码" }}
        </button>
      </div>

      <mat-form-field appearance="outline" *ngIf="methodEmail === 'Email2'">
        <mat-label>密码</mat-label>
        <input
          matInput
          placeholder="请输入登录密码"
          type="password"
          [(ngModel)]="password"
        />
      </mat-form-field>

      <div class="agreement">
        <mat-checkbox [(ngModel)]="agree">
          已阅读并同意<a routerLink="/agreement">用户协议</a>和
          <a routerLink="/privacy">隐私协议</a>
        </mat-checkbox>
      </div>

      <button
        class="login"
        mat-raised-button
        color="primary"
        (click)="loginEmail()"
      >
        {{ methodEmail === "Email1" ? "登录并注册" : "登录" }}
      </button>

      <div class="divider">
        <div class="dashed"></div>
        或者
        <div class="dashed"></div>
      </div>

      <button
        class="login-with-button"
        mat-stroked-button
        color="primary"
        (click)="methodEmail === 'Email1' ? useEmail2() : useEmail1()"
      >
        {{ methodEmail === "Email1" ? "使用密码登录" : "使用验证码登录" }}
      </button>
    </div>
  </ng-container>
</div>
